/**
 * A timestamp from the API. The API keeps UTC; Postgres sends it with an offset, SQLite without
 * one ("2026-10-24T22:13:02"). Read with no offset, the browser would take it as local time and
 * shift it by the reader's zone, so a time with no offset is read as UTC.
 */
export function serverTime(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  let s = iso.trim().replace(/^(\d{4}-\d{2}-\d{2}) (\d)/, "$1T$2");
  if (/T\d{2}:\d{2}/.test(s) && !/(Z|[+-]\d{2}:?\d{2})$/i.test(s)) s += "Z";
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** A date and time in the reader's zone, for example "Oct 23, 2026, 9:00 AM". */
export function when(iso: string): string {
  const d = serverTime(iso);
  return d ? d.toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : iso;
}
